import { Component, input } from '@angular/core';

export type ConflictIndicatorColor = 'gray' | 'purple';

@Component({
  selector: 'ima-conflict-indicator',
  imports: [],
  templateUrl: './conflict-indicator.html',
  styleUrl: './conflict-indicator.scss',
})
export class ConflictIndicator {
  readonly color = input<ConflictIndicatorColor>('gray');

  readonly count = input(0);

  readonly disabled = input(false);

  readonly label = input('');
}
